import React, { useEffect } from "react";
import LinkQrWrapper from "../linkPage/LinkQrWrapper";
import ReviewIcon from "./svg/ReviewIcon";
import useTypeDecription from "../../../hooks/useTypeDecription";
import { useSelector } from "react-redux";

export default function ReviewPage() {
  const lang = useSelector((state) => state.changeLang.language.stepTwo.review);
  const { content, getContent } = useTypeDecription();

  useEffect(() => {
    getContent("google-review");
  }, []);

  return (
    <LinkQrWrapper prefixIcon={<ReviewIcon />} fieldPlaceholder={lang[0]}>
      {content}
    </LinkQrWrapper>
  );
}
